import * as React from 'react'
import { Route, Switch } from 'react-router'
import Modal from 'src/components/ui/Modal'
import { IOrganizationsMetadata, IRiderObject, IStateMetadata, StateOrganizationMap } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import PersonalInfoForm from './PersonalInfoForm'

interface IPersonalInfoPaneProps {
  metadata: IStateMetadata
  rider: IRiderObject
  saveRider: (rider: IRiderObject) => Promise<any>
  currentStep: number
  onCompleteStep: (step: number) => void
  showMessage: (error: string, isError: boolean) => void
  currentOrgId: string
  organizations: StateOrganizationMap
  organizationsFetchingMetaData: IOrganizationsMetadata
  match: any
  history: any
}

interface PersonalInfoFormData {
  tempRiderObject: IRiderObject | undefined
}

class PersonalInfoPane extends React.Component<IPersonalInfoPaneProps, PersonalInfoFormData> {
  constructor(props: any) {
    super(props)
    this.state = {
      tempRiderObject: undefined
    }
    this.setRiderState = this.setRiderState.bind(this)
  }

  public setRiderState(rider: IRiderObject | undefined) {
    this.setState({ tempRiderObject: rider })
  }

  public render() {
    const forceCreateWithSamePhoneNumber = (props: any) => {
      return (
        <React.Fragment>
          <Modal>
            <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
              <div className='bg-white col-3 p2'>
                <span className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase'>
                  {UIMessages.rider.labels.phoneNumberAlreadyExistModalTitle}
                </span>
                <div className='ml2 mr2 mt1 font-grey3 h5'>
                  The phone number already exists, do you still want to proceed with the registration?
                </div>
                <div className='flex items-center justify-end mt3'>
                  <button
                    type='button'
                    onClick={() => this.goBack()}
                    className='CancelButton btn bg-white rounded font-light-grey mr2'
                  >
                    {UIMessages.common.cancel}
                  </button>
                  <button
                    type='button'
                    onClick={() => this.forceSave(this.props.rider)}
                    className='SubmitButton btn bg-green rounded font-white weight-300'
                  >
                    {UIMessages.common.continueLabel}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </React.Fragment>
      )
    }
    return (
      <section>
        <div>
          <PersonalInfoForm
            showMessage={this.props.showMessage}
            currentStep={this.props.currentStep}
            onCompleteStep={this.props.onCompleteStep}
            rider={this.props.rider}
            saveRider={this.props.saveRider}
            currentOrgId={this.props.currentOrgId}
            organizations={this.props.organizations}
            organizationsFetchingMetaData={this.props.organizationsFetchingMetaData}
            setRiderState={this.setRiderState}
          />
          <Switch>
            <Route
              path={`${this.props.match.path}/profile/confirm-phone-number`}
              render={forceCreateWithSamePhoneNumber}
            />
          </Switch>
        </div>
      </section>
    )
  }

  private goBack() {
    this.props.history.goBack()
  }

  private async forceSave(rider: IRiderObject) {
    if (this.state.tempRiderObject) {
      await this.props.saveRider({ ...this.state.tempRiderObject, force: { phoneNumber: true } })
      this.goBack()
    }
  }
}

export default PersonalInfoPane



// WEBPACK FOOTER //
// ./src/components/riders/createrider/personalinfo/PersonalInfoPane.tsx